<div class="demooz_message" 
    [class.text_only]="!this.showIcon"
    [class.info]="this.typeMessage === 'info'"
    [class.success]="this.typeMessage === 'success'"
    [class.warning]="this.typeMessage === 'warning'"
    [class.error]="this.typeMessage === 'error'"     
    [class.secondary]="this.colorButton === 'secondary'"
    [class.blue]="this.colorButton === 'blue'"
    [class.red]="this.colorButton === 'red'"
    [class.green]="this.colorButton === 'green'"
    [class.orange]="this.colorButton === 'orange'"
    [class.purple]="this.colorButton === 'purple'"
    >
    @if(this.showIcon){
        <ion-icon [name]="this.getIcon()"></ion-icon>
    }
    <div>
        <ng-content></ng-content>
    </div>
</div>